var TALKABLE_CONTAINER_Z_INDEX = 10;
var PARTNER_BANNER_CONTAINER_Z_INDEX = 11;
var TOOLTIP_Z_INDEX = 15;
var BANNER_CONTAINER_DEFAULT_Z_INDEX = 18;
var MESSENGER_PANEL_Z_INDEX = 21;
var SWAP_NOTIFICATIONS_Z_INDEX = 25;
var STUDIO_CONTAINER_Z_INDEX = 24;
var APP_NOTIFICATIONS_DESKTOP_Z_INDEX = 25;
var APP_NOTIFICATIONS_MOBILE_Z_INDEX = 25;
var CHECKOUT_MODAL_Z_INDEX = 25;
var PDP_MODAL_Z_INDEX = 26;
var ADDED_TO_CART_FEEDBACK_MODAL_Z_INDEX = PDP_MODAL_Z_INDEX + 1;
var HAMBURGER_MENU_Z_INDEX = 30;
/**
 * Copy of Z_index_modal from nextjs app.
 * Used in web-ui-kit for the shareable header which is used in all apps.
 */

var NEXTJS_MODAL_Z_INDEX = 20;
export { ADDED_TO_CART_FEEDBACK_MODAL_Z_INDEX, APP_NOTIFICATIONS_DESKTOP_Z_INDEX, APP_NOTIFICATIONS_MOBILE_Z_INDEX, BANNER_CONTAINER_DEFAULT_Z_INDEX, CHECKOUT_MODAL_Z_INDEX, HAMBURGER_MENU_Z_INDEX, MESSENGER_PANEL_Z_INDEX, NEXTJS_MODAL_Z_INDEX, PARTNER_BANNER_CONTAINER_Z_INDEX, PDP_MODAL_Z_INDEX, STUDIO_CONTAINER_Z_INDEX, SWAP_NOTIFICATIONS_Z_INDEX, TALKABLE_CONTAINER_Z_INDEX, TOOLTIP_Z_INDEX };